module.exports = __webpack_public_path__ + "img/product3.d09c1164.png";